import 'devextreme/dist/css/dx.light.css';
import './App.css';
import 'devextreme/dist/css/dx.light.css';
import { Route, Routes } from 'react-router-dom';
import { lazy, Suspense } from 'react'; // Add these imports

import MainNavbar from './apps/main-navbar/main-navbar';
import AuthProvider, { useAuth } from './apps/auth/auth-provider/auth-provider';
import { PrivateRoute } from './apps/auth/private-route/private-route';
import AppLogout from './apps/auth/auto-logout/auto-logout';
import StickyFooter from './apps/footer/sticky-footer/sticky-footer';
import { loadMessages, locale } from 'devextreme/localization';
import faMessage from "../src/shared/fa.json";
import { useEffect, useState } from 'react';
import TransactionExpirationDuration from './apps/transaction-expiration-duration/transaction-expiration-duration';
import { AdminRoute } from './apps/auth/admin-route/admin-route';
import OpenDrawerProvider from './apps/custom-providers/open-drawer-provider/open-drawer-provider';
import QuantityDefinitionProvider from './apps/custom-providers/quantity-definition-provider/quantity-definition-provider';
import GoldPriceTypeProvider from './apps/custom-providers/gold-price-type-provider/GoldPriceTypeProvider';

import DimensionProvider from './apps/custom-providers/dimension-provider/DimensionProvider';
import GoldTradingPlatformLoadingProvider from './apps/custom-providers/gold-trading-platform-loading-provider/GoldTradingPlatformLoadingProvider';
import { TransactionOrderTypeProvider } from './apps/custom-providers/transaction-order-type-provider/TransactionOrderTypeProvider';
import { ReceiptApprovationTypeProvider } from './apps/custom-providers/receipt-approvation-type-provider/ReceiptApprovationTypeProvider';
import PriceMarkupTypeProvider from './apps/custom-providers/price-markup-type-provider/PriceMarkupTypeProvider';
import PriceMarkupChangeTypeProvider from './apps/custom-providers/price-markup-change-type-provider/PriceMarkupChangeTypeProvider';
import ProfileDetailProvider from './apps/custom-providers/profile-detail-provider/ProfileDetailProvider';
import LoginPage from './apps/auth/logins/login-page/LoginPage';
import ProfileTradingConfigProvider from './apps/custom-providers/profile-trading-config-provider/ProfileTradingConfigProvider';
import PriceMarkupGroupProvider from './apps/custom-providers/price-markup-group-provider/PriceMarkupGroupProvider';
import { useWindowResizeSync } from './apps/custom-hooks/ui-hooks/useWindowResizeSync';
import { Bounce, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';  // Make sure this is present!
import { ErrorBoundary } from './apps/components/error-boundary/ErrorBoundary';
import { LoadingFallback } from './apps/components/loading-fallback/LoadingFallback';
const DrawerMenu = lazy(() => import('./apps/drawer-menu/drawer-menu'));


function App() {
  const [locale, setLocale] = useState('fa');
  useWindowResizeSync();   // ✅ HERE

  useEffect(() => { 
    loadMessages(faMessage);
  }, [])
  
  return (
    <>
      <DimensionProvider>
        <main className='main'>
          <AuthProvider>
            <ToastContainer 
              rtl={true}
              position="top-right"
              theme="dark"
              draggable
              transition={Bounce}
              autoClose={1000}
              toastClassName="rtl-toast"
              bodyClassName="rtl-toast-body"
            />

            <Routes>
              <Route
                  path='/login'
                  element={<LoginPage />}
              ></Route>
            </Routes>
          
          <PriceMarkupGroupProvider>
          <ProfileTradingConfigProvider>
          <PriceMarkupChangeTypeProvider>
          <ProfileDetailProvider>
            <PriceMarkupTypeProvider>
            <ReceiptApprovationTypeProvider>
              <TransactionOrderTypeProvider>
                <AppLogout>
                  <GoldPriceTypeProvider>
                  <QuantityDefinitionProvider>
                    <OpenDrawerProvider>
                      <GoldTradingPlatformLoadingProvider>
                        <MainNavbar />
                        <ErrorBoundary>
                          <Suspense fallback={<LoadingFallback />}>
                            <DrawerMenu />
                          </Suspense>          
                        </ErrorBoundary>

                      </GoldTradingPlatformLoadingProvider>
                    </OpenDrawerProvider>
                  
                    <Routes>
                        <Route element={<PrivateRoute />}>
                          <Route element={<AdminRoute />}>
                          <Route 
                            path="transaction-expiration-durations/:userId"
                            element={<TransactionExpirationDuration />}
                            />
                          </Route>
                        </Route>
                    </Routes>
                  </QuantityDefinitionProvider>
                  </GoldPriceTypeProvider>
                </AppLogout>
              </TransactionOrderTypeProvider>
            </ReceiptApprovationTypeProvider>
            </PriceMarkupTypeProvider>
          </ProfileDetailProvider>
          </PriceMarkupChangeTypeProvider>
          </ProfileTradingConfigProvider>
          </PriceMarkupGroupProvider>
          
            <StickyFooter />
          </AuthProvider>
        </main>

      </DimensionProvider>

    </>
  );
}

export default App;
